import { useState, useEffect } from "react";
import { Button } from "react-materialize";
import { translations, loginLink } from './common/utils';
import KeyFeatures from './KeyFeatures';
import Footer from './Footer';
import { loadGtag, trackPage } from '../analytics';
import { defaultLanguage } from './common/appSettings';

const Login = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);

  const translate = (key) => translations[selectedLanguage][key];

  const selectLanguageHandler = (lang) => {
    setSelectedLanguage(lang)
  };

  useEffect(() => {
    // Only initialize analytics in production. GA ID is hardcoded in analytics.js.
    // NODE_ENV is set automatically by CRA during the production build.
    const isProduction = process.env.NODE_ENV === 'production';

    if (!isProduction) {
      return;
    }

    (async () => {
      try {
        const loaded = await loadGtag();
        if (!loaded) {
          console.warn('gtag failed to load on landing (possibly blocked by client)');
          return;
        }
        // track landing page view
        trackPage(window.location.pathname + window.location.search);
      } catch (e) {
        // ignore
      }
    })();
  }, []);

  return (
    <div className="login-bg">
      <div className="login-wrap">
        <div className="login-lang-select">
          <Button
            className="lang-button"
            node="button"
            // waves="light"
            onClick={() => selectLanguageHandler('en')}
          >
            (EN) English
          </Button>
          <Button
            className="lang-button"
            node="button"
            // waves="light"
            onClick={() => selectLanguageHandler('uk')}
          >
            (UA) Українська
          </Button>
        </div>
          <div className="login-title">
            <h1>{translate('landingTitle')}</h1>
          </div>
          <Button
            className="login-button"
            node="button"
            waves="light"
            onClick={() => window.location.href = loginLink}
          >
            {translate('login')}
          </Button>
          <KeyFeatures
            translate={translate}
          />
          <Footer translate={translate} />
      </div>
    </div>
  )
};

export default Login;
